import React, { useEffect, useState } from "react";
import { EventBus } from "../../engine/EventBus.js";
import { getDifficulty, DIFFICULTY_TUNING } from "../../engine/combat/difficulty.js";
import type { DifficultyLevel } from "../../engine/combat/difficulty.js";

/**
 * DifficultyChip — small always-visible indicator whenever difficulty
 * sits off Normal, so a pacified (or extra-lethal) world is never
 * mistaken for broken enemy AI. Mounted in both App HUD trees.
 */
const EASY_STYLE = {
  background: "rgba(20,60,30,0.85)",
  color: "#9fe8b0",
  borderColor: "rgba(159,232,176,0.5)",
};
const HARD_STYLE = {
  background: "rgba(70,22,22,0.85)",
  color: "#f0a0a0",
  borderColor: "rgba(240,160,160,0.5)",
};

export function DifficultyChip() {
  const [level, setLevel] = useState<DifficultyLevel>(() => getDifficulty());
  useEffect(
    () =>
      EventBus.on("combat:difficulty_changed", ({ level: next }) => {
        setLevel(next);
      }),
    [],
  );
  if (level === "normal") return null;
  const side = level === "peace" || level === "story" ? EASY_STYLE : HARD_STYLE;
  return (
    <div
      style={{
        position: "absolute",
        top: 8,
        left: "50%",
        transform: "translateX(-50%)",
        border: "1px solid",
        borderRadius: 4,
        padding: "2px 10px",
        fontFamily: "monospace",
        fontSize: 11,
        letterSpacing: 2,
        zIndex: 150,
        pointerEvents: "none",
        ...side,
      }}
    >
      {DIFFICULTY_TUNING[level].label.toUpperCase()}
    </div>
  );
}
